import React from 'react';
import PropTypes from 'prop-types';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonButton,
  IonInput,
  IonText,
  IonProgressBar,
  IonToast
} from '@ionic/react';
import { connect } from 'react-redux'
import { key, cloudUpload } from 'ionicons/icons';

import './Password.css';
import PasswordActions from '../../../actions/password';
import ErrorAlert from '../../../components/ErrorAlert';

interface IProps {
  changeFields: any;
  changePassword: any;
}

interface IState {
  data: any;
}

class Password extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = {data: props.data}
  }

  handleChange(event: any) {
    let fields = this.state.data.fields;
    fields[event.target.name] = event.target.value;
    this.props.changeFields(fields)
  }

  change_Password(){
    this.props.changePassword(this.state.data.fields, "change_password");
  }

  UNSAFE_componentWillReceiveProps(nextProps: any){
    this.setState({
      data: nextProps.data,
    });
  }

  render() {
    const { fields, formErrors, simpleToast, toastMessage } = this.state.data;
    return (
      <IonPage>
        <ErrorAlert/>
        <IonHeader>
          <IonToolbar color="primary">
            <IonTitle>Mi perfil</IonTitle>
            <IonButtons slot="start">
              <IonMenuButton />
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonToast
          isOpen={simpleToast}
          buttons={[
            {
              text: 'Ok',
              role: 'cancel'
            }
          ]}
          message={`${toastMessage}`}
          duration={3000}
        />
        <IonContent fullscreen>
          <IonProgressBar style={ this.state.data.loading ? {display: 'block'} : {display: 'none'}} type="indeterminate"></IonProgressBar>
          <form>
            <IonList lines="full" className="ion-no-margin ion-no-padding">
              <IonItem>
                <IonLabel position="stacked">Contraseña Anterior <IonText color="danger">*</IonText></IonLabel>
                <IonInput type="password" name="current_password"  value={fields.current_password || "" } onIonChange={this.handleChange.bind(this)}></IonInput>
              </IonItem>
              {formErrors.errors && formErrors.errors.current_password && (
                <IonText color="danger" className="ion-padding-start">
                  <small>{formErrors.errors.current_password}</small>
                </IonText>
              )}

              <IonItem>
                <IonLabel position="stacked">Contraseña Nueva <IonText color="danger">*</IonText></IonLabel>
                <IonInput type="password" name="new_password"  value={fields.new_password || "" } onIonChange={this.handleChange.bind(this)}></IonInput>
              </IonItem>
              {formErrors.errors && formErrors.errors.new_password && (
                <IonText color="danger" className="ion-padding-start">
                  <small>{formErrors.errors.new_password}</small>
                </IonText>
              )}

              <IonItem>
                <IonLabel position="stacked">Confirmar Contraseña <IonText color="danger">*</IonText></IonLabel>
                <IonInput type="password" name="confirm_new_password"  value={fields.confirm_new_password || "" } onIonChange={this.handleChange.bind(this)}></IonInput>
              </IonItem>
              {formErrors.errors && formErrors.errors.confirm_new_password && (
                <IonText color="danger" className="ion-padding-start">
                  <small>{formErrors.errors.confirm_new_password}</small>
                </IonText>
              )}

            </IonList>

            <div className="ion-padding">
              <IonButton expand="block" className="ion-no-margin" onClick={this.change_Password.bind(this)} disabled={this.state.data.loading}><IonIcon icon={cloudUpload} />&nbsp;Guardar</IonButton>
            </div>
          </form>
        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data,
    changeFields: PropTypes.func.isRequired
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    changeFields: (fields: any) => dispatch(PasswordActions.changeFields(fields)),
    changePassword: (fields: any, typeOption: any) => dispatch(PasswordActions.changePassword(fields, typeOption))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Password);

